<template>
    <div>
        <main>
            <v-container>
                <v-flex xs12 sm8 offset-sm2 class="text-xs-center">
                    <v-card class="pa-4">
                        <template v-if="!err && !success">
                            <h2>{{$lang.global.paymentProgress}}</h2>
                            <p class="grey--text">{{$lang.global.pleaseWait}}</p>
                          <div id="loaderInner">
                            <div class="spinner">
                              <div class="bounce1"></div>
                              <div class="bounce2"></div>
                              <div class="bounce3"></div>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                            <v-alert
                                    color="success"
                                    class="success"
                                    icon="check"
                                    value="true"
                                    v-if="success">{{success}}
                            </v-alert>
                            <v-alert
                                    color="error"
                                    class="err"
                                    icon="warning"
                                    value="true"
                                    v-if="err">{{err}}
                            </v-alert>
                        </template>
                    </v-card>
                </v-flex>
            </v-container>
        </main>
    </div>
</template>

<script>
  export default {
    data: () => ({
      err: '',
      success: '',
      interval: null,
    }),
    methods: {
      orderFailed() {
        clearInterval(this.interval);
        this.err = this.$lang.errors.paymentFailed;
        setTimeout(() => {
          this.$router.push({ name: 'orderInfo' });
        }, 30000);
      },
      fetchOrderStatus(orderId, resourceId) {
        this.$webHelper.get(`payment/fetchpaymentstatus/${resourceId}/${orderId}`, null, this.$router)
          .then((res) => {
            if (!res.success || !res.body.paymentStatus) {
              this.orderFailed();
              return;
            }
            switch (res.body.paymentStatus.toLowerCase()) {
              case 'open':
              case 'inprocess':
                setTimeout(() => {
                  this.fetchOrderStatus(orderId, resourceId);
                }, 7000);
                break;
              case 'success':
                this.success = this.$lang.success.paymentOrderOk;
                clearInterval(this.interval);
                this.$storage.order = null;
                this.$store.dispatch('clearCart');
                setTimeout(() => {
                  this.$router.push({
                    name: 'resourceSet',
                    props: { resource: resourceId },
                    query: { nologout: true },
                  });
                }, 15000);
                break;
              case 'failed':
              case 'statusnotknown':
              default: {
                this.orderFailed();
              }
            }
          });
      },
      setOrderStatusInterval() {
        this.fetchOrderStatus(this.$route.params.orderId, this.$route.params.resourceId);
      },
      paymentsenseSubmitPaymentStatus() {
        const query = this.$route.query;
        if (!query.HashDigest || !query.MerchantID || !query.CrossReference || !query.OrderID) {
          this.err = this.$lang.errors.malformedPayment;
          setTimeout(() => {
            this.$router.push({ name: 'webShop' });
          }, 3000);
          return;
        }
        this.$webHelper.post('payment/submithostedpaymentformresult', {
          hashDigest: query.HashDigest,
          merchantId: query.MerchantID,
          crossReference: query.CrossReference,
          orderId: query.OrderID,
        }, this.$router)
          .then((res) => {
            if (!res.success) {
              // eslint-disable-next-line max-len
              this.err = res.body && res.body.statusText ? res.body.statusText : this.$lang.errors.submitFailed;
              return;
            }
            this.setOrderStatusInterval();
          });
      },
      connectEPaymentStatus(id) {
        this.$webHelper.get(`payment/fetchconnectepaymentinfo/${id}`, null, this.$router)
          .then((res) => {
            console.log(res);
            // if (!res.success || !res.body.paymentStatus) {
            //   this.orderFailed();
            //   return;
            // }
            // switch (res.body.paymentStatus.toLowerCase()) {
            //   case 'open':
            //   case 'inprocess':
            //     setTimeout(() => {
            //       this.fetchOrderStatus(orderId, resourceId);
            //     }, 7000);
            //     break;
            //   case 'success':
            //     this.success = this.$lang.success.paymentOrderOk;
            //     clearInterval(this.interval);
            //     this.$storage.order = null;
            //     this.$store.dispatch('clearCart');
            //     setTimeout(() => {
            //       this.$router.push({
            //         name: 'resourceSet',
            //         props: { resource: resourceId },
            //         query: { nologout: true },
            //       });
            //     }, 15000);
            //     break;
            //   case 'failed':
            //   case 'statusnotknown':
            //   default: {
            //     this.orderFailed();
            //   }
            // }
          });
      },
    },
    created() {
      if (this.$route.params.resourceId) {
        localStorage.setItem('webShopResourceId', this.$route.params.resourceId);
      }
      const company = JSON.parse(localStorage.company);
      if (company.paymentGateway === 'paymentsense') {
        this.paymentsenseSubmitPaymentStatus();
      }
      if (company.paymentGateway === 'firstdata') {
        this.setOrderStatusInterval();
      }
      if (company.paymentGateway === 'connect-e') {
        this.connectEPaymentStatus();
      }
    },

  };
</script>

<style scoped lang="scss">
    main {
        display: flex;
        align-items: center;
    }

    img {
        width: 150px;
        margin: 15px auto;
    }

    #loaderInner {
      .spinner {
        margin: 10px auto 0 !important;
        width: 100%;
        text-align: center;
      }

      .spinner > div {
        width: 24px;
        height: 24px;
        background-color: #efa546;

        border-radius: 100%;
        display: inline-block;
        -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
        animation: sk-bouncedelay 1.4s infinite ease-in-out both;
      }

      .spinner .bounce1 {
        -webkit-animation-delay: -0.32s;
        animation-delay: -0.32s;
      }

      .spinner .bounce2 {
        -webkit-animation-delay: -0.16s;
        animation-delay: -0.16s;
      }

      @-webkit-keyframes sk-bouncedelay {
        0%, 80%, 100% { -webkit-transform: scale(0) }
        40% { -webkit-transform: scale(1.0) }
      }

      @keyframes sk-bouncedelay {
        0%, 80%, 100% {
          -webkit-transform: scale(0);
          transform: scale(0);
        } 40% {
            -webkit-transform: scale(1.0);
            transform: scale(1.0);
          }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/Payments.vue